<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--project-edit">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">
            PWAマニフェスト生成
          </div>
        </div>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <form>
        <!-- プロジェクト内容の入力フォーム -->
        <div class="l-main-content">
          <div class="p-project-edit">
            <!-- 入力 | 選択リスト -->
            <ul class="p-project-edit-list">
              <!-- タイトル -->
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  :title="'プロジェクトURL'"
                  :placeholder="''"
                  :data="project.url"
                  :is-readonly="true"
                  :error-message="getErrorMessage('project.url')"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-project-edit">
            <div v-show="isLoading" class="c-loader c-loader"></div>
            <!-- 入力 | 選択リスト -->
            <ul v-show="!isLoading" class="p-project-edit-list">
              <!-- タイトル -->
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="name"
                  :title="'アプリ名'"
                  :description="'ホーム画面に追加時に利用されます'"
                  :placeholder="''"
                  :data="pwa.name"
                  :error-message="''"
                  @value-changed="pwa.name = $event"
                />
              </li>
              <!-- /タイトル -->

              <!-- ショートタイトル -->
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="shortName"
                  :title="'アプリ名（アイコン）'"
                  :description="'アプリアイコンに利用されます（8文字以下推奨）'"
                  :placeholder="''"
                  :data="pwa.short_name"
                  :error-message="''"
                  @value-changed="pwa.short_name = $event"
                />
              </li>
              <!-- /ショートタイトル -->

              <!-- スタートページ -->
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="startUrl"
                  :title="'スタートページ'"
                  :description="'アプリ起動時のURLを指定してください'"
                  :placeholder="''"
                  :data="pwa.start_url"
                  :error-message="''"
                  @value-changed="pwa.start_url = $event"
                />
              </li>
              <!-- /スタートページ -->

              <!-- スコープ -->
              <li v-show="false" class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="scope"
                  :title="'スコープ'"
                  :description="'アプリ表示が有効な範囲（パス）を指定してください'"
                  :placeholder="''"
                  :data="pwa.scope"
                  :error-message="''"
                  @value-changed="pwa.scope = $event"
                />
              </li>
              <!-- /スコープ -->

              <!-- 説明 -->
              <li class="p-project-edit-list__item">
                <ValidatableTextArea
                  ref="description"
                  :title="'アプリ説明'"
                  :description="'ホーム画面に追加時に利用されます(Android)'"
                  :placeholder="''"
                  :data="pwa.description"
                  :error-message="''"
                  @value-changed="pwa.description = $event"
                />
              </li>
              <!-- /説明 -->

              <li v-show="false" class="p-project-edit-list__item">
                <div style="display: flex">
                  <!-- 表示モード -->
                  <div style="margin-right: 30px">
                    <div class="c-input__title">
                      アプリ表示モード
                    </div>
                    <div class="c-input__text">
                      iOSではfullscreen,
                      standaloneのみ有効
                    </div>
                    <select-text
                      ref="display"
                      input-name="main-category-select"
                      place-holder="表示モードを選択してください"
                      :classes="['u-w300']"
                      :elements="displays"
                      :value="pwa.display"
                      @select="pwa.display = $event"
                    />
                  </div>
                  <!-- /表示モード -->

                  <!-- 表示方向 -->
                  <div>
                    <div class="c-input__title">
                      表示方向
                    </div>
                    <div class="c-input__text">
                      Androidのみ有効
                    </div>
                    <select-text
                      ref="orientation"
                      input-name="main-category-select"
                      place-holder="表示方向を選択してください"
                      :classes="['u-w300']"
                      :elements="orientations"
                      :value="pwa.orientation"
                      @select="pwa.orientation = $event"
                    />
                    <!-- /表示方向 -->
                  </div>
                </div>
              </li>

              <li class="p-project-edit-list__item">
                <div style="display: flex">
                  <!-- テーマカラー -->
                  <div>
                    <ValidatableColorInput
                      ref="themeColor"
                      :title="'テーマカラー'"
                      :placeholder="''"
                      :data="pwa.theme_color"
                      :error-message="''"
                      @value-changed="
                        pwa.theme_color = $event
                      "
                    />
                  </div>
                  <!-- /テーマカラー -->
                  <!-- 背景カラー -->
                  <div>
                    <ValidatableColorInput
                      ref="backgroundColor"
                      :title="'背景カラー'"
                      :placeholder="''"
                      :data="pwa.background_color"
                      :error-message="''"
                      @value-changed="
                        pwa.background_color = $event
                      "
                    />
                  </div>
                  <!-- /背景カラー -->
                </div>
              </li>

              <li class="p-project-edit-list__item">
                <div class="p-message-edit-list__item">
                  <div class="c-upload">
                    <div class="c-upload__title">
                      アイコン
                    </div>

                    <label class="c-upload__label">
                      <div class="c-upload__image">
                        <img v-if="pwa.icon_binary" :src="pwa.icon_binary" />
                        <div v-else class="c-upload__noimage">
                          <div class="c-icon c-icon--gray-3 u-wh30">
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <use xlink:href="/assets/img/sprite.svg#photo" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div class="c-upload__data">
                        <input
                          ref="iconInput"
                          type="file"
                          value=""
                          placeholder="ファイルの選択"
                          @change="onFileChange"
                        />
                        <span class="c-upload__btn">ファイルの選択</span>
                        <div class="c-upload__filename"></div>
                        <div class="c-upload__text c-upload__text--spec">
                          サイズ：縦512x横512px<br />
                          形式：PNG奨励(JPG可)
                        </div>
                      </div>
                    </label>
                    <div class="c-error c-error--balloon c-error--upload-badge" :class="{'is-active': getErrorMessage('icon_binary')}">
                      <div class="c-error__text">{{ getErrorMessage('icon_binary') }}</div>
                    </div>
                  </div>
                </div>

                <table class="c-table icon-table">
                  <thead>
                    <tr>
                      <th style="width: 80px;"></th>
                      <th>URL</th>
                      <th style="width: 100px;">サイズ</th>
                      <th style="width: 120px;">タイプ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, key) in pwa.icons" :key="key">
                      <td class="c-table__cell--left c-table__cell--middle">
                        <img :src="value.src" width="50" />
                      </td>
                      <td class="c-table__cell--left c-table__cell--middle">
                        <a :href="value.src" target="_blank" rel="noopener">{{ value.src }}</a>
                      </td>
                      <td class="c-table__cell--left c-table__cell--middle">
                        {{ value.sizes }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ value.type }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="c-text" style="text-align: right;"><a href="https://manual.webpush.jp/posts/feature-pwa" rel="noopener noreferrer" target="_blank">マニュアルはこちら</a></div>
            <!-- /入力 | 選択リスト -->
          </div>
        </div>
        <!-- /プロジェクト内容の入力フォーム -->
        <!-- ボタンエリア -->
        <div class="l-main-content">
          <div class="p-project-btns">
            <a class="c-btn c-btn--gray u-w320 u-h50 u-fs--xl" @click="onClickCancel">
              <p class="c-btn__text">キャンセル</p>
            </a>
            <button
              class="c-btn c-btn--modal c-btn--blue u-w320 u-h50 u-fs--xl"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isProcessing"
              type="button"
              name="edit"
              value="edit"
              @click="onClickGenerate"
            >
              <p class="c-btn__text">マニフェストを作成</p>
            </button>
          </div>
          <div class="p-pwa-ios-message">
            ※iOSに対応したブラウザプッシュタグの更新はお済みですか？<a class="p-pwa-ios-message-a" target="_blank" :href="'/coins-admin/project/edit/' + project.service_id +'#browser-push-tag'">タグ設定はこちら。</a>
          </div>
        </div>
        <!-- /ボタンエリア -->
      </form>
    </main>
    <PwaManifestCopyPopup ref="popup" />
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    breadcrumbData: Array,
    project: Object,
  },
  data: function () {
    return {
      pwa: {
        name: "",
        short_name: "",
        start_url: "/?utm_source=pwa",
        scope: "/",
        description: "",
        display: "standalone",
        orientation: "portrait",
        theme_color: "#FFFF00",
        background_color: "#000000",
        icon_binary: "",
        icons: [],
      },
      displays: {
        fullscreen: "fullscreen",
        standalone: "standalone",
        "minimal-ui": "minimal-ui",
        browser: "browser",
      },
      orientations: {
        any: "any",
        natural: "natural",
        landscape: "landscape",
        "landscape-primary": "landscape-primary",
        "landscape-secondary": "landscape-secondary",
        portrait: "portrait",
        "portrait-primary": "portrait-primary",
        "portrait-secondary": "portrait-secondary",
      },
      isLoading: false,
      isProcessing: false,
      errors: {},
      acceptableMimeTypes: ["image/png", "image/jpeg", "image/gif"],
    };
  },
  computed: {},
  mounted: function () {
    this.$refs.display.setValue(this.pwa.display);
    this.$refs.orientation.setValue(this.pwa.orientation);
    this.getSiteData();
  },
  methods: {
    getSiteData: function () {
      this.isLoading = true;
      const url = this.project.url;
      const endpoint = `/api/projects/pwa/${this.project.service_id}`;
      axios
        .get(endpoint, { params: { url } })
        .then((res) => {
          if (res.data.latest_manifest) {
            this.applyFromManifest(res.data.latest_manifest);
          } else if (res.data.manifest_url) {
            this.applyFromManifest(res.data.manifest);
          } else {
            this.applyFromSiteData(res.data.site);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error?.response?.data?.errors) {
            this.errors = error.response.data.errors;
          }
          this.isLoading = false;
        });
    },
    applyFromManifest: function (data) {
      this.$refs.name.changeValue(data.name);
      this.$refs.shortName.changeValue(data.short_name);
      this.$refs.startUrl.changeValue(data.start_url);
      if (data.scope) {
        this.$refs.scope.changeValue(data.scope);
      }
      this.$refs.description.changeValue(data.description);
      this.pwa.display = data.display;
      this.pwa.orientation = data.orientation;
      this.$refs.themeColor.changeValue(data.theme_color);
      this.$refs.backgroundColor.changeValue(data.background_color);
      if (data.icons && data.icons.length) {
        this.pwa.icons = data.icons;
      }
    },
    applyFromSiteData: function (data) {
      if (data.title) {
        this.$refs.name.changeValue(data.title.substring(0, 45));
        this.$refs.shortName.changeValue(data.title.substring(0, 12));
      }
      this.$refs.description.changeValue(data.description);
      if (data.icons && data.icons.length) {
        this.pwa.icons = data.icons;
      }
    },
    isAcceptableMimeType: function (mimeType) {
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function (acceptableMimeType) {
        if (acceptableMimeType == mimeType) {
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },
    onFileChange: function (event) {
      const file = event.target.files[0];
      delete this.errors['icon_binary'];

      if (!this.isAcceptableMimeType(file.type)) {
        this.errors['icon_binary'] = ['アイコンはPNG/JPEG/GIF形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${file.type};base64,${base64}`;
        self.pwa.icon_binary = data;
      };
      fileReader.readAsDataURL(file);
    },
    onClickCancel: function () {
      history.back();
    },
    getErrorMessage: function (key) {
      var error = this.errors[key];
      return error ? error[0] : '';
    },
    onClickGenerate: function () {
      this.isProcessing = true;
      const endpoint = `/api/projects/pwa/${this.project.service_id}`;
      const data = JSON.parse(JSON.stringify(this.pwa));
      if (!this.pwa.icon_binary) {
        delete data["icon_binary"];
      }
      axios
        .post(endpoint, data)
        .then((res) => {
          this.$refs.popup.setValue(res.data.manifest_url);
          this.$refs.popup.open();
          this.isProcessing = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.isProcessing = false;
        });
    },
  },
};
</script>
